import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
  Alert,
  showToast,
} from "../../../../../../components";
import common from "../../../../../../utils/common";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateOtherPaymentsStart } from "../../../../../../redux/slices/payroll/payrollSlice";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { deleteFile } from "../../../../../../redux/slices/universal/fileUploadApi";

const PayOtherPaymentModal2 = ({
  open,
  onClose,
  setActiveTab,
  initialData,
  mode = "create",
  employeeProfileUiid,
}) => {
  const dispatch = useDispatch();
  const { formData, errors, handleChange, setFormData } = useFormHandler({});
  const { convertLocalFormatMMDDYYYY } = common;
  const [showUnpaidModal, setShowUnpaidModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (mode === "edit" && initialData) {
      let clients =
        Array.from(
          new Set(
            initialData?.timesheetId?.map((ts) => ts.clientId?.businessName) ||
              [],
          ),
        )?.join(", ") || "";

      setFormData({
        ...formData,
        comments: initialData.comments || "",
        paymentDate: initialData.payDate
          ? convertLocalFormatMMDDYYYY(initialData.payDate)
          : "",
        totalTimeSheetValue: initialData?.amounts?.total || "",
        paidAmount: initialData?.amounts?.paid || "",
        pendingAmount: initialData?.amounts?.pending || "",
        ExchangeAmount: initialData?.exchange?.amt || "",
        project: clients,
        attachment: "", // Clear attachment to ensure no stale file is present
      });
    } else if (open && mode === "create") {
      // Optional: Reset form if needed when opening in create mode,
      // though useFormHandler might handle initial state.
      // If we want to ensure clear state on re-open:
      // setFormData({ comments: "", paymentDate: "", ... });
      // But let's stick to pre-filling for Edit.
    }
  }, [initialData, mode, open]);

  const accumulatedAmount = 276899.4;

  const handleSaveLogic = () => {
    if (mode === "edit" ? initialData?._id : true) {
      const proceedWithUpdate = (
        attachmentKey = null,
        oldKeyToRemove = null,
      ) => {
        let keyToDelete = oldKeyToRemove;
        if (!keyToDelete && mode === "edit" && initialData?.attachments?.length > 0) {
            keyToDelete = initialData.attachments[0];
        }
        let updatePayload = {
          comments: formData.comments,
          payDate: formData.paymentDate,
        };

        if (attachmentKey) {
          const existingAttachments = initialData?.attachments || [];

          // Filter out the old key if we were performing a replacement
          const filteredAttachments = oldKeyToRemove
            ? existingAttachments.filter((k) => k !== oldKeyToRemove)
            : existingAttachments;

          // Add the new key
          const uniqueAttachments = Array.from(
            new Set([...filteredAttachments, attachmentKey]),
          );
          updatePayload.attachments = uniqueAttachments;
        }

        const payload = [
          {
            type: "SET",
            value: updatePayload,
          },
        ];

        dispatch(
          updateOtherPaymentsStart({
            coll: "EmpOtherPay",
            uiid: initialData.uiid,
            payload: payload,
            onSuccess: () => {            
              if (keyToDelete) {               
                  if (typeof deleteFile === 'function') {
                     deleteFile({ coll: "EmpOtherPay", key: keyToDelete })
                       .then((res) => console.log("Old file deleted:", res))
                       .catch((err) => console.error("Error deleting old file:", err));
                  } else {
                     console.error("deleteFile is NOT a function. Check imports.", deleteFile);
                  }
              }
              setShowAlert(false);
              onClose();
            },
          }),
        );
      };

      let fileToUpload = null;
      if (formData.attachment instanceof File) {
        fileToUpload = formData.attachment;
      } else if (
        Array.isArray(formData.attachment) &&
        formData.attachment.length > 0 &&
        formData.attachment[0] instanceof File
      ) {
        fileToUpload = formData.attachment[0];
      }

      if (fileToUpload) {
        // New file selected
        // Check if we are checking overwriting an existing file
        let existingKey = null;
        if (mode === "edit" && initialData?.attachments?.length > 0) {
          existingKey = initialData.attachments[0]; // Assuming single file replacement overrides the first one or we pick the relevant one
        }

        if (mode === "edit" && initialData?.attachments?.length > 0) {
          existingKey = initialData.attachments[0]; 
        }
        
        dispatch(
          uploadStart({
            coll: "EmpOtherPay",
            entity: "employees",
            category: "otherPayments",
            uiid: employeeProfileUiid,
            doc: fileToUpload,
            uploadType: "single",
            fileIds: existingKey, // Pass existing key to overwrite/delete in backend
            onSuccess: (data) => {
              // Inspecting logs: it returns { url: ..., key: ... } inside data
              let key = data;
              if (Array.isArray(data)) {
                key = data[0];
              }
              if (typeof key === "object" && key !== null && key.key) {
                key = key.key;
              }

              proceedWithUpdate(key, existingKey);
            },
          }),
        );
      } else {
        proceedWithUpdate();
      }
    } else {
      console.log("Confirmed Save:", formData);
      setShowAlert(false);
    }
  };

  const handleSave = () => {
    setShowAlert(true);
  };

  const handleClearFile = () => {
    setFormData((prev) => ({ ...prev, attachment: "" }));
  };

  return (
    <>
      <Modal
        isOpen={open}
        onClose={onClose}
        title={mode === "edit" ? "UPDATE PAYMENT" : "PAY OTHER PAYMENT"}
        width="max-w-6xl"
      >
        <div>
          {mode !== "edit" && (
            <div className="flex">
              <div className="text-sm font-semibold">
                Total Pending Amount
                <br />
                <span className="text-lg text-black-600 font-bold">
                  ${accumulatedAmount}
                </span>
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-6 max-w-7xl mt-4">
            <div className="flex flex-col">
              {mode !== "edit" && (
              <Button
                title="Show Unpaid Timesheets"
                onClick={() => {
                  //   setShowUnpaidModal(true);
                  setActiveTab((prev) => prev + 2)
                }}
                className="w-42 h-10 mt-4"
              />
                    )}
            </div>

            <FormFieldSet
              type="text"
              title="Total TimeSheet Value"
              placeholder="Enter Total TimeSheet Value"
              value={formData.totalTimeSheetValue}
              onChange={(value) => handleChange("totalTimeSheetValue", value)}
              error={errors.totalTimeSheetValue}
              disabled={mode === "edit"}
            />
            <FormFieldSet
              type="text"
              title="Project"
              placeholder="Enter Project"
              value={formData.project}
              onChange={(value) => handleChange("project", value)}
              error={errors.project}
              disabled={mode === "edit"}
            />
            <div className="hidden lg:block"></div>

            <FormFieldSet
              type="text"
              title="Paid Amount"
              placeholder="Enter Paid Amount"
              value={formData.paidAmount}
              onChange={(value) => handleChange("paidAmount", value)}
              error={errors.paidAmount}
              disabled={mode === "edit"}
            />

            <div className="col-span-1 sm:col-span-2 flex gap-1 items-end">
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title="Exchange Amount"
                  placeholder="Enter Rate"
                  value={formData.ExchangeAmount}
                  onChange={(value) => handleChange("ExchangeAmount", value)}
                  error={errors.ExchangeAmount}
                disabled={mode === "edit"}
                />
              </div>
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title=" "
                  placeholder="Amount"
                  value={formData.Exchangeamout2}
                  onChange={(value) => handleChange("Exchangeamout2", value)}
                  error={errors.Exchangeamout2}
                  disabled={mode === "edit"}
                />
              </div>
            </div>

            <div className="mt-5">
              {mode !== "edit" && (
                <Button title="Auto Adjust" onClick={() => { }} size="sm" />
              )}
            </div>
            <div className="hidden lg:block"></div>

            <FormFieldSet
              type="text"
              title="Pending Amount"
              placeholder="Enter Pending Amount"
              value={formData.pendingAmount}
              onChange={(value) => handleChange("pendingAmount", value)}
              error={errors.pendingAmount}
              disabled={mode === "edit"}
            />
            <FormFieldSet
              type="text"
              title="Payment Date"
              placeholder="MM/DD/YYYY"
              value={formData.paymentDate}
              onChange={(value) => handleChange("paymentDate", value)}
              error={errors.paymentDate}
            />
            <div className="hidden lg:block"></div>
            <div className="hidden lg:block"></div>

            <FormFieldSet
              type="file"
              title="Attachment"
              placeholder="Choose File"
              value={formData.attachment}
              onChange={(value) => handleChange("attachment", value)}
              error={errors.attachment}
            />
            <FormFieldSet
              type="textArea"
              title="Comments"
              placeholder="Enter Comments"
              value={formData.comments}
              onChange={(value) => handleChange("comments", value)}
              error={errors.comments}
            />
          </div>

          <div className="flex gap-3 justify-end mt-3">
            <Button title="Cancel" variant="outlined" onClick={onClose} />
            <Button title="Update" onClick={handleSave} />
          </div>
        </div>
      </Modal>

      {/* <UnapaidtimesheetdetailsModel
        open={showUnpaidModal}
        onClose={() => setShowUnpaidModal(false)}
      /> */}

      <Alert
        isOpen={showAlert}
        onClose={() => setShowAlert(false)}
        title="This transaction cannot be retrieved"
        cancelButton={{
          show: true,
          title: "No",
          onClick: () => setShowAlert(false),
        }}
        acceptButton={{
          show: true,
          title: "Yes",
          onClick: handleSaveLogic,
        }}
      />
    </>
  );
};

export default PayOtherPaymentModal2;
